import React from "react";
import PopularArticles from '../components/popular-articles'
import ZipFinderState from "../components/zip-finder-state";
import LayoutDumpster from "../components/layout-dumpster";
import CitiesListState from "../components/cities-list-state";

const STATEPAGEDUMPSTER = ({ pageContext }) => 
{
	const articles = pageContext.articles

	const code = pageContext.code;
    const codes = pageContext.codes.length > 0 ? pageContext.codes : [];
    const state = pageContext.state;
	const env = pageContext.env;	
	const cities = pageContext.cities.length > 0 ? pageContext.cities : [];

	const seo_desc = pageContext.seo_desc;
    const seo = 
    {
        url: pageContext.url,
        env: env,
        code: code,
        page: 'state',
		state: state,
        seo_desc: seo_desc
    }

    const pickTitle = () => {
        let title = "Find {state} {code}";
        codes.map(element => {
            if (code === element.code) {
                title = title.replace('{code}', element.name);
            }
            return true
        })
        if (state !== undefined) {
            title = title.replace('{state}', state.name);
        }
        return title
    }

    const pickText = () => {
        let text = "We’ll introduce you to top {code} providers in your area";
        codes.map(element => {
            if (code === element.code) {
                text = text.replace('{code}', element.name.toLowerCase());
            }

            return true;
        })

        return text;
    }

	return (
		<LayoutDumpster seo={seo} env={env} code={code} >

			<ZipFinderState
				id = 'home-zip-code'
				code = {code}						
				button = "Find Pros"
				bottomtext = "America's #1 Source for Dumpsters and Junk Removal"
				state = {pageContext.state}
                url = {pageContext.url}
                codes = {codes}
				env = {env}
                title = {pickTitle()}
                text = {pickText()}
				finderopenmodal = {false}
				/> 

			<CitiesListState 
                cities = {cities}
				code = {code}
                state = {state}
                codes = {codes}
                env ={env} 
			/>

            <div className='stateArticles'>
                <PopularArticles articles={articles} />
            </div>
  
        </LayoutDumpster>
	)
};

export default STATEPAGEDUMPSTER;